import debounce from 'lodash/debounce'

export default {
  props: {
    value: {},
    label: {
      type: String,
      default: '',
    },
    progress: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    placeholderCapitalized: {
      type: Boolean,
      default: true,
    },
    itemValue: {
      type: String,
      default: 'default',
    },
    itemTitle: {
      type: String,
      default: 'name',
    },
    itemTitleList: {
      type: String | null,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: [],
    },
    requestInterval: {
      type: Number,
      default: 700,
    },
    isValid: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      openSelect: false,
      selectedItem: this.value,
    }
  },
  watch: {
    selectedItem() {
      this.$emit('input', this.selectedItem)
    },
    value() {
      this.selectedItem = this.value
    },
  },
  created() {
    this.selectedItem = this.value
  },
  methods: {
    changeSelect(item) {
      this.selectedItem = item[this.itemTitle]
      this.$emit('input', this.selectedItem)
      this.$emit('select-item', item)
    },

    handleInput: debounce(function (event) {
      this.$emit('handle-input', event.target.value)
    }, 500),

    changeShowTooltipList(status) {
      setTimeout(() => {
        if (status) this.$emit('reset-list')
        this.openSelect = status
      }, 200)
    },
  },
}
